<div class="container">
  <div *ngIf="showCloseButton" class="close-button-wrapper">
    <button
      class="close-button button-reset focus-link cursor-pointer"
      [attr.aria-label]="'modal.close' | translate"
      (click)="onRequestClose()">
      <rd-shared-icon
        class="close-icon h-6 w-6"
        [iconSymbol]="'icon-close'"></rd-shared-icon>
    </button>
  </div>
  <h2 *ngIf="title" class="title">{{ title }}</h2>
  <section class="content">
    <ng-container *ngTemplateOutlet="dialogContent"> </ng-container>
  </section>
  <div *ngIf="showButtons" class="button-wrapper">
    <rd-shared-button
      *ngIf="showSecondaryButton"
      class="secondary-button focus-link"
      [ngClass]="secondaryButtonClass"
      [buttonClass]="'secondary-button ' + secondaryButtonClass"
      [buttonContent]="secondaryButtonContent"
      [buttonTheme]="secondaryButtonTheme"
      [isDisabled]="secondaryButtonIsDisabled"
      (clickFn)="onSecondaryClickEmit()">
      <ng-template #secondaryButtonContent>
        <span>{{ secondaryButtonText }}</span>
      </ng-template>
    </rd-shared-button>

    <rd-shared-button
      class="primary-button focus-link"
      [ngClass]="[
        primaryButtonClass,
        primaryButtonFullWidth ? 'full-width-button' : ''
      ]"
      [ariaLabel]="primaryButtonAriaLabel"
      [buttonClass]="'primary-button ' + primaryButtonClass"
      [buttonContent]="primaryButtonContent"
      [buttonTheme]="primaryButtonTheme"
      [isDisabled]="primaryButtonIsDisabled"
      (clickFn)="onPrimaryClickEmit()">
      <ng-template #primaryButtonContent>
        <span>{{ primaryButtonText }}</span>
      </ng-template>
    </rd-shared-button>
  </div>
</div>
